var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{staticClass:"add-channel",attrs:{"to":"#"}},[_c('div',{staticClass:"add-circle"},[_c('img',{attrs:{"src":require("assets/svg/compiled/plus.svg"),"width":"13px"}})]),_vm._v("Add a new Line")])}
var staticRenderFns = []

export { render, staticRenderFns }